import { Injectable } from "@angular/core";
import { IGlobalParameter, IPreference, IPreferenceUser, PreferenceContext } from "@comunicare/comunicare-interfaces";
import { IPreferenceService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { Observable, of } from "rxjs";
import { map, tap } from "rxjs/operators";
import { SessionService } from "../shared/services/session.service";
import { PreferenceApiService } from "./preferences.api";

@Injectable({
  providedIn: "root",
})
export class PreferencesService implements IPreferenceService {
  // tslint:disable-next-line:no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  private listCache: Record<string, any> = [];

  constructor(
    private preferenceApi: PreferenceApiService,
    private sessionService: SessionService
  ) {}

  // tslint:disable-next-line:no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  public list(context: string): Observable<null | any> {
    if (this.listCache[context] !== undefined) {
      return of(this.listCache[context]);
    }

    return this.preferenceApi.list(context).pipe(
      map((parameters) => {
        if (!parameters) {
          return null;
        }
        return parameters;
      }),
      tap((parameters) => {
        this.listCache[context] = parameters;
      })
    );
  }

  public update(preference: IPreference): Observable<IPreferenceUser> {
    this.listCache[preference.context] = undefined;

    if (preference.context === PreferenceContext.GLOBAL) {
      this.sessionService.globalPref = preference.parameters;
    }
    return this.preferenceApi.update(preference);
  }

  public getGlobal(): Observable<null | IGlobalParameter> {
    const globalParameter = this.sessionService.globalPref;
    if (!globalParameter) {
      return this.preferenceApi.list(PreferenceContext.GLOBAL).pipe(
        tap((parameters: IGlobalParameter) => {
          this.sessionService.globalPref = parameters;
        })
      );
    } else {
      return this.sessionService.getObservablePref();
    }
  }

  public getAutoRefreshWidget(): number {
    return 60000;
  }

  public getAutoSaveInterval(): number {
    return 10000;
  }
}
